export { default } from './AiChatFooter';
